'use client'
import { PrismicRichText } from "@prismicio/react";
import { PrismicNextImage } from "@prismicio/next";
import { isFilled } from "@prismicio/client";
import CtaSimple from "@/components/CtaSimple";

/**
 * @typedef {import("@prismicio/client").Content.ImgAndTextSlice} ImgAndTextSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<ImgAndTextSlice>} ImgAndTextProps
 * @type {import("react").FC<ImgAndTextProps>}
 */
const ImgAndText = ({ slice }) => {
  const { title, cta, description, img } = slice.primary;

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="bg-white framing overflow-hidden text-dark-green"
    >
      <div className="w-full max-w-375 mx-auto my-14 lg:my-20 flex gap-25 items-stretch">
        <div className="w-100 xl:w-119 h-auto relative rounded-lg overflow-hidden hidden lg:block">
          {isFilled.image(img) && (
            <PrismicNextImage
              field={img}
              className="w-full h-full top-0 absolute block object-cover object-center"
              loading="lazy"
            />
          )}
        </div>
        <div className="flex-1 flex flex-col gap-14 flex-1 lg:py-6">
          <div className="flex flex-col gap-6">
            {isFilled.richText(title) && (
              <PrismicRichText
                field={title}
                components={{
                  heading1: ({ children }) => (
                    <h1 className="h3">
                      {children}
                    </h1>
                  ),
                  heading2: ({ children }) => (
                    <h2 className="h3">
                      {children}
                    </h2>
                  ),
                  heading3: ({ children }) => (
                    <h3 className="h3">
                      {children}
                    </h3>
                  ),
                }}
              />
            )}
            <div className="flex gap-10">
              {isFilled.richText(description) && (
                <div className="flex flex-col gap-5">
                  <PrismicRichText
                    field={description}
                    components={{
                      heading2: ({ children }) => (
                        <h2 className="h3">
                          {children}
                        </h2>
                      ),
                      heading3: ({ children }) => (
                        <h3 className="h3">
                          {children}
                        </h3>
                      ),
                    }}
                  />
                  {isFilled.link(cta) && (
                    <div className="flex lg:hidden mt-5 w-full">
                      <CtaSimple page={cta} padding={"px-5"} width={"w-full md:w-auto"} />
                    </div>
                  )}
                </div>
              )}
            </div>
            <div className="w-full lg:hidden md:mt-12">
              {isFilled.image(img) && (
                <PrismicNextImage
                  field={img}
                  className="w-full h-auto max-h-80 md:max-h-120 object-cover rounded-lg object-center"
                  loading="lazy"
                />
              )}
            </div>
          </div>
          {isFilled.link(cta) && (
            <div className="hidden lg:flex">
              <CtaSimple page={cta} padding={"px-5"} width={"w-auto"} hover={"dark-green"} />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ImgAndText;
